export default __webpack_public_path__ + "static/portfolio-parallax-0993dc9392d54fce1d56132690172904.jpg";